import { render } from "./ReservationTable.vue?vue&type=template&id=6f1a214a&scoped=true"
import script from "./ReservationTable.vue?vue&type=script&lang=js"
export * from "./ReservationTable.vue?vue&type=script&lang=js"

import "./ReservationTable.vue?vue&type=style&index=0&id=6f1a214a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1a214a"]])

export default __exports__